<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card v-if="data">
        <v-toolbar dark color="secondary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Protocollo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn v-if="data.protocollata" dark flat @click="download">Scarica</v-btn>
            <v-btn v-else dark flat @click="confirm">Protocolla e scarica</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <embed
          v-if="file64"
          class="embed-protocollo"
          width="100%"
          :src="file64"
          type="application/pdf"
        >
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "acc-protocollo-anteprima",
  components: {},
  props: {
    data: {
      type: Object
    },
    isShow: {
      default: false
    }
  },
  data: () => ({
    dialog: false
  }),
  computed: {
    file64() {
      return this.data ? this.data.file : "";
    }
  },
  watch: {
    isShow(val) {
      this.dialog = val;
    }
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("on-close");
    },
    download() {
      this.$emit("on-donwload");
    },
    confirm() {
      this.$emit("on-confirm");
    }
  }
};
</script>

<style lang="scss">
.v-dialog--fullscreen {
  overflow-y: hidden !important;
  .v-card {
    height: 100%;
    .embed-protocollo {
      /*height: calc(100% - 64px);*/
      margin-top: -50px;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/ProtocolloAnteprima.vue